import type { NavigationKey } from '@/i18n/keys';

/** Route metadata read by AppLayout to show the section name in the header bar. */
export interface RouteHandle {
  titleKey: NavigationKey;
}

export const handle = (titleKey: NavigationKey): RouteHandle => ({ titleKey });
